// eslint-disable-next-line import/prefer-default-export
export function getPostRoute(post) {
  let name;
  let params;

  if (post.publicKey) {
    name = 'publicPost';
    params = {
      alias: post.alias,
      publicKey: post.publicKey,
    };
  } else {
    name = 'post';
    params = {
      alias: post.alias,
    };
  }

  return { name, params };
}



// WEBPACK FOOTER //
// ./src/router/helper.js